import { render, staticRenderFns } from "./RolesIcon.vue?vue&type=template&id=6a729204&"
import script from "./RolesIcon.vue?vue&type=script&lang=js&"
export * from "./RolesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports